(function() {
    
    "use strict";
    
    document.addEventListener('DOMContentLoaded', function () {

        const elements = document.querySelectorAll('[back-img]');

        elements.forEach(function (element) {

            const DEV = 0;

            DEV && log('element', element)

            element.classList.add('not-visible');

            var url = element.getAttribute('back-img');

            if (NodeList.prototype.forEach === undefined) {
                NodeList.prototype.forEach = Array.prototype.forEach;
            }

            const options = {
                // root: window,
                // rootMargin: "25px",
                threshold: [0.1]
            };

            // create new observer
            var observer = new IntersectionObserver(onChange, options);

            // observe element
            observer.observe(element);

            function onChange(changes) {
                changes.forEach(function (change) {
                    if (change.intersectionRatio > 0.1) {
                        var el = change.target;

                        if (DEV) {
                            console.log('change', change);
                            console.log('el', el);
                            console.log('Item visible');
                        }

                        var image = new Image();
                        image.src = url;

                        image.onload = function () {
                            el.style.backgroundImage = "url(" + url + ")";
                            el.classList.add('fade-in-when-visible');
                            el.classList.remove('not-visible');
                            observer.unobserve(el);
                            // document.dispatchEvent(new CustomEvent('loaderOff', { detail: true }));
                        };
                    }
                });
            }
        });
    });
})();